import { ENDPOINT } from '~/constants/endpoints';

import { VestigasHTTPError } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type MatchCompanyRequest, type MatchCompanyResponse } from './types';
import {
  zodMatchCompanyRequestSchema,
  zodMatchCompanyResponseSchema,
} from './validations';

/**
 * Checks if a company with a similar name and address already exists.
 *
 * @param data - The company name and address to match against.
 * @returns The matched company if found, or null if no match.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/get_company_match_by_name_and_address_vadmin_company_match_post
 */
export const matchCompany = async (
  data: MatchCompanyRequest,
): Promise<MatchCompanyResponse> => {
  try {
    return await vestigasApi
      .post(ENDPOINT.COMPANY.MATCH(), {
        json: data,
        validate: {
          body: zodMatchCompanyRequestSchema,
          response: zodMatchCompanyResponseSchema,
        },
      })
      .json<MatchCompanyResponse>();
  } catch (error) {
    if (error instanceof VestigasHTTPError && error.response.status === 404) {
      // Ignore 404 errors as those are expected
      return null;
    }

    throw error;
  }
};
